import * as React from 'react';
import { IMaskInput } from 'react-imask';
import cx from 'classnames';

import * as styles from './styles.css';

export interface IMaskedInput {
  value: string;
  invalid: boolean;
  size?: 'large' | 'small';
  onChange(value: string): void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
}

export const MaskedInput: React.FC<IMaskedInput> = ({ value, invalid, size, onChange, onFocus, onBlur }) => {
  return (
    <div className={cx(styles['input-wrapper'], invalid && styles['input-wrapper--invalid'])}>
      <IMaskInput
        mask="+7 (000) 000 00 00"
        type="phone"
        className={cx(styles['input'], styles[`input-${size || 'large'}`])}
        placeholder="+7 "
        value={value}
        unmask={false}
        onAccept={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};
